import { useQuery } from '@tanstack/react-query';
import { isServer } from '../../utils/utils';
import { EMPTY_SLT_CONFIG_DATA } from './SLTConfigProvider';
import { serverConfigsRequest, serverConfigsRequestSync } from './serverConfigsRequest';
import type { SLTServerConfig } from './SLTConfigProvider';

export function useSLTAppConfigs(): SLTServerConfig {
    const { data: sfccConfigs = EMPTY_SLT_CONFIG_DATA } = useQuery({
        queryKey: ['sfccConfigs'],
        queryFn: () => serverConfigsRequest(),
        initialData: serverConfigsRequestSync(),
        enabled: isServer,
    });

    return sfccConfigs;
}
